import * as React from 'react';

const Activity = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={10} height={10} fill="none" {...props}>
        <path
            fill="currentColor"
            d="M5 7.625a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25m0-4a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75M4.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M1.245 1.995a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M0 5a.75.75 0 1 0 1.5 0A.75.75 0 0 0 0 5m1.245 3.005a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M4.25 9.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m3.005-1.245a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M8.5 5A.75.75 0 1 0 10 5a.75.75 0 0 0-1.5 0M7.255 1.995a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
        />
        <path fill="currentColor" d="M5 3.625a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75" />
    </svg>
);
export default Activity;
